import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50381cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-social-media" }
const _hoisted_2 = { class: "contact-social-media__item" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "contact-social-media__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "m20.2 7.616-.988 3.494c.953-4.01-1.512-8.161-5.477-9.122l4.255.816c1.224.512 2.538 2.678 2.21 4.812zM2.314 6.914l.808-3.395C3.631 1.385 5.776.58 7.892.571l3.363.815C7.29.425 3.267 2.912 2.314 6.914zm8.179-5.37c4.681 0 8.475 3.829 8.475 9.426 0 3.851-3.794 7.681-8.475 7.681-4.681 0-8.313-3.83-8.313-7.681 0-5.597 3.632-9.426 8.313-9.426zM8.95 3.878c-2.179 0-3.252 1.083-3.252 2.419 0 1.337 1.073 2.42 3.252 2.42.469 0 1.543-1.083 1.543-2.42 0-1.336-1.074-2.419-1.543-2.419zm7.605 3.62c0-1.337-1.074-1.718-2.398-1.718s-2.397.381-2.397 1.718c0 1.336 1.073 2.42 2.397 2.42a2.41 2.41 0 0 0 2.398-2.42zm-3.676 8.858c1.323 0 2.397-1.083 2.397-2.42a2.409 2.409 0 0 0-2.397-2.419 2.408 2.408 0 0 0-2.398 2.419 2.408 2.408 0 0 0 2.398 2.42zm-2.447-5.11c.708 0 1.053-.476 1.053-1.063s-.345-1.062-1.053-1.062c-.582 0-1.053.475-1.053 1.062 0 .587.471 1.063 1.053 1.063zm-3.616 3.91c1.324 0 2.398-.436 2.398-2.42a2.409 2.409 0 0 0-2.398-2.42 2.408 2.408 0 0 0-2.397 2.42c0 1.984 1.073 2.42 2.397 2.42zm.434 3.05-3.363-.815C1.772 16.878.458 14.712.966 12.578l.808-3.395c-.952 4.002 1.512 8.062 5.476 9.023zm11.422-4.925-.809 3.394c-.507 2.135-2.653 3.461-3.913 2.949l-4.219-.816c3.965.961 7.988-1.526 8.941-5.527z"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "contact-social-media__item" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "contact-social-media__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "15"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "m19.634 2.91.024-.657c-.232-.849-.861-1.503-1.66-1.742l-.017-.004C16.478.88 10.432.88 10.432.88S4.402.8 2.884.507C2.69.75 1.44 1.404 1.211 2.236l-.004.017c-.562 3.01-.565 6.627.025 9.851l-.025-.163c.233.848 1.473 1.503 1.66 1.741l.017.004c1.501.42 7.549.42 7.549.42s6.03 0 7.549-.42a2.477 2.477 0 0 0 1.673-1.728l.004-.017c.256-1.4.951-3.012.951-4.658 0-.06 0-.121-.01-.182.01.349.01-.123.01-.19 0-1.646-.695-3.257-.976-4.001zM8.503 10.107V4.94l5.032 2.165-5.032 3.002z"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "contact-social-media__item" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "contact-social-media__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M17.317 17.91h-3.535v-6.372c0-1.323-.027-3.02-1.841-3.02-.951 0-2.124 1.438-2.124 2.925v6.467H6.28V5.685h3.397v1.556h.05c.472-.897 1.628-1.842 4.053-1.842 2.881 0 3.54 2.361 3.54 5.426v7.085h-.003zM2.289 4.13C1.156 4.13.237 3.192.237 2.59.237.927 1.156.8 2.289.8 3.42.8 4.339.927 4.34 2.59c0 .602-.919 1.54-2.051 1.54zM4.61 17.91H.519V5.686H4.61V17.91z"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "contact-social-media__item" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "contact-social-media__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18.858 13.316c-.126 3.214-1.411 4.261-3.114 4.922-1.252.486-2.475.483-6.017.483-3.452 0-5.87.233-6.897-1.543C.342 15.435.541 13.105.541 9.526c0-3.236-.226-5.882 2.289-7.652C3.141.815 4.453.456 5.94.386c1.693-.075 5.883-.079 7.574 0 3.46.16 5.192 2.119 5.344 5.349.075 1.695.079 5.887 0 7.581zm-1.599-3.791c0-1.825-.01-2.746-.053-3.716-.076-4.251-3.395-3.824-7.477-3.824l-.035-.022c-2.457 0-2.744.011-3.72.837-4.247-.574-3.813 2.477-3.813 6.714 0 3.131-.234 5.196 1.057 6.481 1.121 1.125 2.657 1.645 6.487 1.645 3.719 0 5.615-.473 6.486-.94 1.139-1.839 1.067-3.385 1.068-7.175zm-2.628-3.804c-.411 0-1.102-.494-1.102-1.103 0 .282.691-1.104 1.102-1.104.609 0 1.102 1.386 1.102 1.104 0 .609-.493 1.103-1.102 1.103zm-4.904 8.527c-2.605 0-3.827-2.113-3.827-4.722 0-2.607 1.22-4.722 3.827-4.722a4.72 4.72 0 0 1 4.717 4.722 4.719 4.719 0 0 1-4.717 4.722zm0-7.787c-1.377 0-3.062 1.372-3.062 3.065 0 1.693 1.685 3.065 3.062 3.065a3.063 3.063 0 0 0 3.062-3.065 3.063 3.063 0 0 0-3.062-3.065z"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "contact-social-media__item" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "contact-social-media__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M17.893 4.36c.811-.9 1.493-1.619 2.049-2.447a8.549 8.549 0 0 1-2.356.645c.848-.038 2.224-1.301 1.799-2.259a8.178 8.178 0 0 1-2.593.989C16.42.489 14.972.5 13.805.5c-2.263 0-4.086 1.332-4.086 4.34 0-.432.028-.12.095.33C6.415 4.85 3.406 3.222 1.386.739c-.056.613-.56 1.781-.56 2.067 0 1.416.728 2.671 1.816 3.398a4.047 4.047 0 0 1-1.847-.503v.045c0 1.986 1.417 3.637 3.905 4.017-.963.092-1.325.135-1.702.135-.261 0-.526-.015-.773-.07.529 1.619 2.034 2.81 4.225 2.849-1.796 1.088-3.562 1.744-5.475 1.744-.335 0-.657-.015-.775-.056C1.809 15.533 3.954 16.2 6.269 16.2c7.217 0 11.92-6.02 11.624-11.84z"
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "contact-social-media__item" }
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "contact-social-media__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1.311 7.147C6.434 4.879 9.85 3.384 11.559 2.662 16.439.599 17.453.241 18.114.229c.145-.002.47.034.681.208.177.146.415.344.655.483.23.67.52.456.29.703-.93 2.824-2.075 9.675-1.91 12.837-.993 1.338-1.478 1.787-1.948 1.831-1.02.095-1.012-.685-1.892-1.344-2.438-1.03-3.312-1.671-4.813-2.676-1.735-1.162-.61-1.8.379-2.844.258-.273 4.755-4.429 4.842-4.805.01-.048.02-.223-.082-.316-.103-.093.294-.061-.364-.036-.155.036-2.626 1.695-7.412 4.978-.701.489-1.337.728-1.906.715.066-.013-1.834-.36-2.731-.656C.802 8.943.71 8.751.4 8.134c.03-.322.079-.651.911-.987z"
  })
], -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createElementVNode("a", {
        rel: "nofollow",
        class: "contact-social-media__link",
        href: _ctx.SOCIAL.APARAT,
        target: "_blank",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "bottom",
        "data-bs-offset": "0,10",
        title: "Follow Us On Aparat"
      }, _hoisted_5, 8, _hoisted_3)
    ]),
    _createElementVNode("li", _hoisted_6, [
      _createElementVNode("a", {
        rel: "nofollow",
        class: "contact-social-media__link",
        href: _ctx.SOCIAL.YOUTUBE,
        target: "_blank",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "bottom",
        "data-bs-offset": "0,10",
        title: "Follow Us On Youtube"
      }, _hoisted_9, 8, _hoisted_7)
    ]),
    _createElementVNode("li", _hoisted_10, [
      _createElementVNode("a", {
        rel: "nofollow",
        class: "contact-social-media__link",
        href: _ctx.SOCIAL.LINKEDIN,
        target: "_blank",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "bottom",
        "data-bs-offset": "0,10",
        title: "Follow Us On Linkedin"
      }, _hoisted_13, 8, _hoisted_11)
    ]),
    _createElementVNode("li", _hoisted_14, [
      _createElementVNode("a", {
        rel: "nofollow",
        class: "contact-social-media__link",
        href: _ctx.SOCIAL.INSTAGRAM,
        target: "_blank",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "bottom",
        "data-bs-offset": "0,10",
        title: "Follow Us On Instagram"
      }, _hoisted_17, 8, _hoisted_15)
    ]),
    _createElementVNode("li", _hoisted_18, [
      _createElementVNode("a", {
        rel: "nofollow",
        class: "contact-social-media__link",
        href: _ctx.SOCIAL.TWITTER,
        target: "_blank",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "bottom",
        "data-bs-offset": "0,10",
        title: "Follow Us On Twitter"
      }, _hoisted_21, 8, _hoisted_19)
    ]),
    _createElementVNode("li", _hoisted_22, [
      _createElementVNode("a", {
        rel: "nofollow",
        class: "contact-social-media__link",
        href: _ctx.SOCIAL.TELEGRAM,
        target: "_blank",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "bottom",
        "data-bs-offset": "0,10",
        title: "Follow Us On Telegram"
      }, _hoisted_25, 8, _hoisted_23)
    ])
  ]))
}